var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ac-preview", {
        attrs: { campaignData: _vm.getCampaignData },
        on: {
          deleteMpe: _vm.deleteMpe,
          editMpe: _vm.editMpe,
          updateCampaign: _vm.updateCampaign
        }
      }),
      _vm._v(" "),
      _vm.editing !== null
        ? _c("editor-wrapper", {
            attrs: { mpeId: _vm.editing },
            on: { discardChanges: _vm.discardChanges, saveMpe: _vm.saveMpe }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-189a87ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189a87ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/campaignManager/CampaignPreview.vue
// module id = null
// module chunks = 